import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, ['index', 'fileType', 'paymentFolio']);
  const createBatchPaymentFileConfig = `createBatchPaymentFileConfig(input: ${dataModify})`;
  return gql`
  mutation {
    ${createBatchPaymentFileConfig} {
      id
    }
  }
`;
};
